import React, { useEffect, useState } from 'react';

const MONO = '"Geist Mono", ui-monospace, monospace';

const safeEnv = (key, fallback) => {
  try { if (import.meta?.env?.[key]) return import.meta.env[key]; } catch {}
  try { if (process?.env?.[key]) return process.env[key]; } catch {}
  return fallback;
};

const PatentBadge = () => {
  const rawEnabled = String(safeEnv('REACT_APP_PATENT_BADGE_ENABLED', 'true') ?? 'true').toLowerCase();
  const frontendEnabled = !(rawEnabled === 'false' || rawEnabled === '0' || rawEnabled === 'off');
  const frontendText = safeEnv('REACT_APP_PATENT_BADGE_TEXT', 'Patent Pending — U.S. Provisional Application Filed August 2025') || 'Patent Pending — U.S. Provisional Application Filed August 2025';
  const backendUrl = safeEnv('REACT_APP_BACKEND_URL', '');

  const [config, setConfig] = useState({ enabled: frontendEnabled, text: frontendText });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (!backendUrl) return;
        const res = await fetch(`${backendUrl}/api/meta/patent-badge`);
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled) {
          const enabled = String(data?.enabled ?? 'true').toLowerCase();
          setConfig({
            enabled: !(enabled === 'false' || enabled === '0' || enabled === 'off'),
            text: data?.text || frontendText,
          });
        }
      } catch {}
    })();
    return () => { cancelled = true; };
  }, [backendUrl]);

  if (!config.enabled) return null;

  return (
    <div style={{ fontSize: '0.68rem', lineHeight: 1.4, fontFamily: MONO }}>
      <a
        data-testid="patent-badge"
        href="/legal/patents"
        style={{
          color: 'rgba(255,255,255,0.14)',
          textDecoration: 'underline',
          textUnderlineOffset: 2,
          textDecorationColor: 'rgba(255,255,255,0.1)',
          transition: 'color 150ms',
        }}
        onMouseEnter={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.35)'; }}
        onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.14)'; }}
      >
        {config.text}
      </a>
    </div>
  );
};

export default PatentBadge;
